module.exports = __webpack_public_path__ + "img/logo-house-medium-1.2697d132.svg";